// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/phone-call.js';

import { paths } from '../generated/phone-call';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('phone-call', Original, paths);
